import SvgFigure from "~/components/svgFigure"
import svg from "./svg"
import Figure from "~/components/figure"

export default class FirstCurves extends Component {
  render() {
    const neurons = [379, 406, 385, 343, 342, 388, 340, 330, 349, 324]
    const ZoomedImg = ({ src, size, padding, ...props }) => (
      <Surface
        width={size}
        height={size}
        overflow="hidden"
        borderRadius={5}
        position="relative"
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{ position: "absolute", left: -padding, top: -padding }}
        />
      </Surface>
    )

    const ModuleTitle = ({ children, subtitle, fontSize = 16, ...props }) => (
      <Surface
        flexFlow="row"
        marginY={6}
        marginLeft={15}
        marginTop={15}
        {...props}
      >
        <Text
          fontSize={fontSize}
          opacity={0.7}
          fontWeight={600}
          marginLeft={15}
        >
          {children}
        </Text>
        {subtitle && (
          <Text
            fontSize={fontSize}
            opacity={0.4}
            fontWeight={600}
            marginLeft={5}
          >
            {subtitle}
          </Text>
        )}
      </Surface>
    )

    return (
      <Figure>
        <Surface>
          <Surface>
            <FigureHeading>The Location of Curves in InceptionV1</FigureHeading>
          </Surface>
          <Surface
            alignSelf="center"
            marginY={10}
            style={{ transform: `translateX(-60px)` }}
          >
            <SvgFigure
              replaceColors={{
                "63696B": ({ width, height }) => (
                  <div
                    style={{
                      background: "white",
                      borderRadius: 5,
                      width: width - 2,
                      height: height - 2,
                      border: "1px solid rgba(0, 0, 0, 0.2)",
                      alignSelf: "center",
                      justifySelf: "center",
                    }}
                  >
                    <ModuleTitle subtitle="3b">Curve Neurons</ModuleTitle>
                    <Surface
                      flexFlow="row"
                      alignSelf="center"
                      justifySelf="center"
                      flexWrap="wrap"
                      justifyContent="center"
                    >
                      {neurons.map(neuron => (
                        <Surface margin={5} alignItems="center">
                          <ZoomedImg
                            src={neuronFeatureVis(
                              "inceptionv1",
                              "mixed3b",
                              neuron,
                            )}
                            size={65}
                            padding={10}
                          />
                          <Text size={400} fontWeight={500} opacity={0.8}>
                            3b:{neuron}
                          </Text>
                        </Surface>
                      ))}
                    </Surface>
                  </div>
                ),
              }}
            >
              {svg}
            </SvgFigure>
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
class FirstCurvesBack extends Component {
  render() {
    const neurons = [379, 406, 385, 343, 342, 388, 340, 330, 349, 324]
    const neuronSize = 100
    const ZoomedImg = ({ src, size, padding, ...props }) => (
      <Surface
        width={size}
        height={size}
        overflow="hidden"
        borderRadius={5}
        position="relative"
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{ position: "absolute", left: -padding, top: -padding }}
        />
      </Surface>
    )

    const ModuleTitle = ({ children, subtitle, fontSize = 22 }) => (
      <Surface flexFlow="row" marginY={6}>
        <Text
          fontSize={fontSize}
          opacity={0.7}
          fontWeight={600}
          marginLeft={10}
        >
          {children}
        </Text>
        {subtitle && (
          <Text
            marginLeft={5}
            fontSize={fontSize}
            opacity={0.4}
            fontWeight={600}
            marginLeft={10}
          >
            {subtitle}
          </Text>
        )}
      </Surface>
    )

    const notCurve = [
      {
        layer: "mixed3a",
        neuron: 100,
        text: "Angle",
      },
      {
        layer: "mixed3b",
        neuron: 337,
        text: "Cross",
      },
      {
        layer: "mixed3b",
        neuron: 454,
        text: "Spiral",
      },
      {
        layer: "mixed4b",
        neuron: 100,
        text: "Circle",
      },
      {
        layer: "conv2d2",
        neuron: 157,
        text: "Edge",
      },
      {
        layer: "mixed3b",
        neuron: 365,
        text: "Hourglass",
      },
    ]

    const neuronImage = (layer, neuron) =>
      `https://storage.googleapis.com/fls/nickc/neuron_renders/${layer}_${neuron}.jpg`

    return (
      <Figure>
        <Surface flexFlow="row" alignSelf="center">
          <Surface marginX={20}>
            <ModuleTitle subtitle="InceptionV1">Curve Detectors</ModuleTitle>
            <Surface
              display="grid"
              gridTemplateColumns={`repeat(5, auto)`}
              gridTemplateRows={`repeat(2, auto)`}
              padding={5}
              borderRadius={5}
              marginTop={10}
              // style={{ border: `2px solid rgba(0, 0, 0, 0.2)` }}
              // boxShadow="0 30px 60px -12px rgba(50,50,93,.04), 0 18px 36px -18px rgba(0,0,0,.06), 0 -12px 36px -8px rgba(0,0,0,.025)"
            >
              {neurons.map(neuron => (
                <Surface margin={5}>
                  <ZoomedImg
                    size={neuronSize}
                    padding={10}
                    src={neuronImage("mixed3b", neuron)}
                  />
                  <Text
                    marginLeft={10}
                    size={500}
                    fontWeight={500}
                    opacity={0.9}
                    marginTop={3}
                  >
                    3b:{neuron}
                  </Text>
                </Surface>
              ))}
            </Surface>
          </Surface>
          <Surface marginX={20}>
            <ModuleTitle subtitle="InceptionV1">Similar Neurons</ModuleTitle>
            <Surface
              padding={5}
              flexFlow="row"
              borderRadius={5}
              marginTop={10}
              flexWrap="wrap"
              width={400}
              // style={{ border: `2px solid rgba(0, 0, 0, 0.2)` }}
              // boxShadow="0 30px 60px -12px rgba(50,50,93,.04), 0 18px 36px -18px rgba(0,0,0,.06), 0 -12px 36px -8px rgba(0,0,0,.025)"
            >
              {notCurve.map(({ text, layer, neuron }) => (
                <Surface margin={5}>
                  <ZoomedImg
                    size={neuronSize}
                    padding={10}
                    src={neuronImage(layer, neuron)}
                  />
                  <Text
                    marginLeft={10}
                    size={500}
                    fontWeight={500}
                    opacity={0.9}
                    marginTop={3}
                  >
                    {text}
                  </Text>
                </Surface>
              ))}
            </Surface>
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
